import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';

import Calendar from '../../components/shared/Calendar';
import CalendarIcon from '../../images/calendar_icon.svg';

import JourneyAction from '../../components/shared/JourneyAction';
import JourneyActionManager from '../../components/shared/JourneyActionManager';
import JourneyWithNextSchedule from '../../components/shared/JourneyWithNextSchedule';
import { SessionLimiterStrong } from '../../components/shared/Divider';
import PatientCareContact from '../../components/shared/PatientCareContact';
import { customEventTracking } from '../../lib/gtm';
import Ebook from '../../components/shared/Ebook';
import JourneysViewModel from './viewModel';
import YearFilter from './YearFilter';
import ViewMoreWrapper from '../../components/shared/ViewMoreWrapper';

const Journeys = () => {
  const {
    isLoading,
    noActiveJourneys,
    expanded,
    years,
    selectedYear,
    setSelectedYear,
    yearItems,
    hasMore,
    showMore,
    scheduling
  } = JourneysViewModel();

  return (
    <>
      {!isLoading ? <></> : <CircularProgress sx={{ color: 'brand.darkGreen' }} />}

      {!isLoading && (
        <>
          {years.length > 0 && (
            <YearFilter years={years} selectedYear={selectedYear} onSelectYear={setSelectedYear} />
          )}

          {yearItems.map(item =>
            item.kind === 'finalized' ? (
              <Box key={item.journey.journeyid}>
                <JourneyWithNextSchedule journey={item.journey} schedule={item.schedule} variant="finalized" />
              </Box>
            ) : (
              <JourneyActionManager key={item.journey.journeyid} variant="pending" journey={item.journey} />
            )
          )}

          {!expanded && noActiveJourneys && (
            <Box>
              <JourneyAction
                icon={<img alt={'Calendar Icon'} src={CalendarIcon} className="image" width={51} />}
                title="Não há jornadas programadas... ainda!"
                subtitle="Planeje uma consulta e mantenha a sua saúde em dia com acolhimento do início ao fim"
              >
                <Link
                  href={`${process.env.REACT_APP_SCHEDULE_CLIENT_URL}/selecao-de-servicos`}
                  sx={{ textDecoration: 'none' }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowOutwardOutlinedIcon />}
                    onClick={() => {
                      customEventTracking.send({
                        event: 'agendar_home_mc'
                      });
                    }}
                  >
                    Agendar agora
                  </Button>
                </Link>
              </JourneyAction>
            </Box>
          )}

          {!expanded && hasMore && (
            <ViewMoreWrapper>
              <Button variant="inline" color="primary" onClick={showMore}>
                ver mais
              </Button>
            </ViewMoreWrapper>
          )}

          <Ebook />

          <SessionLimiterStrong />

          <PatientCareContact />
        </>
      )}
      {scheduling === 'initialize' && <Calendar />}
    </>
  );
};

export default Journeys;
